<template>
 <section class="featured sliderhome current-1 wrapper" data-hash="8" id="heroheader">    
    <ul id="scene0" class="current scene game-featured game-1"
        data-friction-x="0.1"
        data-friction-y="0.1"
        data-scalar-x="45"
        data-limit-x="190"
        data-limit-y="220"
        data-scalar-y="25">
        <li class="layer" data-depth="0">
            <img src="/static/assets/images/Layer1Kickstarter.jpg" alt="dwerve" class="background"/>
        </li>
          <li class="layer" data-depth="0">
            <img src="/static/assets/images/Dwerve-Crossbow-349.gif" alt="dwerve" class="crossbow" id="crossbow">
        </li>
        <li class="layer" data-depth="0">
            <img src="/static/assets/images/Dwerve-Slice-Tower-532.gif" alt="dwerve" class="slice-tower" id="slice-tower">
        </li>
        <li class="layer" data-depth="0.1">
            <img src="/static/assets/images/Layer2op.png" alt="dwerve" class="images" />
        </li>
        <li class="layer" data-depth="0.2">
            <img src="/static/assets/images/Layer3op.png" alt="dwerve" class="images" />
        </li>
        <li class="layer" data-depth="0.3">
            <img src="/static/assets/images/Dwerve-Title-PJ.png" alt="dwerve" class="game-title dwerveTitle"/>
        </li>
    </ul>
  
        <div id="text-scroll" class="text-scroll animated animated-delay-3">
            <div class="text-scroll-inner">   
               <sendyInlineKickstarter></sendyInlineKickstarter>
              <!-- <a href="https://store.steampowered.com/app/1132760/Dwerve/"  rel="noopener noreferrer" target="_blank" class="myButton bounce_button animated pulse infinite">Play free demo</a> -->
               <!-- <SendyInline></SendyInline> -->
            </div>
        </div>
     

</section>
</template>

<script>
import sendyInlineKickstarter from "@/components/sendyInlineKickstarter.vue";
import Mailtrain from "@/views/Home/MailTrain.vue";
import FollowModal from "@/views/Home/FollowModal.vue";
import SendyModal from "@/views/Home/SendyModal.vue";
import SendyInline from "@/views/Home/SendyInline.vue";
export default {
  data: function() {
    return {};
  },
  methods: {
    resizeGIFs() {
      var windowWidth = document.documentElement.clientWidth;
      var windowHeight = document.documentElement.clientHeight;
      var actualBackgroundWidth = 1920;
      var actualBackgroundHeight = 1080;
      var targetAspectRatio = 1920 / 1080;
      var actualAspectRatio = windowWidth / windowHeight;
      var actualSliceWidth = 533;
      var actualSliceHeight = 403;
      var sliceAspectRatio = actualSliceWidth / actualSliceHeight;
      var actualSliceDistanceTop = 409;
      var actualSliceDistanceRight = 407;
      var sliceDistanceAspectRatio =
        actualSliceDistanceRight / actualSliceDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var sliceHeight =
          actualSliceHeight * windowHeight / actualBackgroundHeight;
        var sliceWidth = sliceHeight * sliceAspectRatio;
        var sliceTop =
          actualSliceDistanceTop * windowHeight / actualBackgroundHeight;
        var sliceRight = sliceTop * sliceDistanceAspectRatio;
      } else {
        var sliceWidth = actualSliceWidth * windowWidth / actualBackgroundWidth;
        var sliceHeight = sliceWidth / sliceAspectRatio;
        var sliceRight =
          actualSliceDistanceRight * windowWidth / actualBackgroundWidth;
        var sliceTop = sliceRight / sliceDistanceAspectRatio;
      }
      document.getElementById("slice-tower").style.top = sliceTop + "px";
      document.getElementById("slice-tower").style.right = sliceRight + "px";
      document.getElementById("slice-tower").style.height = sliceHeight + "px";
      document.getElementById("slice-tower").style.width = sliceWidth + "px";
      var actualArrowWidth = 348;
      var actualArrowHeight = 250;
      var arrowAspectRatio = actualArrowWidth / actualArrowHeight;
      var actualArrowDistanceTop = 224;
      var actualArrowDistanceRight = 1220;
      var arrowDistanceAspectRatio =
        actualArrowDistanceRight / actualArrowDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var arrowHeight =
          actualArrowHeight * windowHeight / actualBackgroundHeight;
        var arrowWidth = arrowHeight * arrowAspectRatio;
        var arrowTop =
          actualArrowDistanceTop * windowHeight / actualBackgroundHeight;
        var arrowRight = arrowTop * arrowDistanceAspectRatio;
      } else {
        var arrowWidth = actualArrowWidth * windowWidth / actualBackgroundWidth;
        var arrowHeight = arrowWidth / arrowAspectRatio;
        var arrowRight =
          actualArrowDistanceRight * windowWidth / actualBackgroundWidth;
        var arrowTop = arrowRight / arrowDistanceAspectRatio;
      }
      document.getElementById("crossbow").style.top = arrowTop + "px";
      document.getElementById("crossbow").style.right = arrowRight + "px";
      document.getElementById("crossbow").style.height = arrowHeight + "px";
      document.getElementById("crossbow").style.width = arrowWidth + "px";
    },
    setZIndex(){
      if(document.getElementById("myFollowModal").style.display == "block") {
        document.getElementById("navbar").style.zIndex = "1";
        document.getElementById("socialNav").style.zIndex = "1"
      }
      else{
        document.getElementById("navbar").style.zIndex = "2";
        document.getElementById("socialNav").style.zIndex = "2"
      }
     
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.resizeGIFs);
      this.resizeGIFs();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeGIFs);
  },
  components: {
    Mailtrain,
    FollowModal,
    SendyModal,
    SendyInline,
    sendyInlineKickstarter
  }
};
</script>


<style scoped>
@keyframes bounce {
	0%, 100%, 20%, 50%, 80% {
		-webkit-transform: translateY(0);
		-ms-transform:     translateY(0);
		transform:         translateY(0)
	}
	40% {
		-webkit-transform: translateY(-30px);
		-ms-transform:     translateY(-30px);
		transform:         translateY(-30px)
	}
	60% {
		-webkit-transform: translateY(-15px);
		-ms-transform:     translateY(-15px);
		transform:         translateY(-15px)
	}
}
.bounce_button:hover {
  -webkit-animation: shake 0.5s;
    animation: shake 0.5s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    -webkit-transform: translatey(0px);
            transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    -webkit-transform: translatey(-20px);
            transform: translatey(-20px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    -webkit-transform: translatey(0px);
            transform: translatey(0px);
  }
}
.myButton {
    box-shadow: inset 0px 2px 4px 0px #97c4fe;
    background: linear-gradient(to bottom, #259bcb 50%, #216fa3 100%);
    background-color: #42ddce;
    border-radius: 4px;
    border: 0px solid #47cfca;
    display: inline-block;
    cursor: pointer;
    color: #ffffff;
    font-family: Digitalt;
    font-size: 36px;
    transition: all .5s;
    font-weight: 100;
    padding: 6px 34px;
    text-decoration: none;
    text-shadow: 1px 1px 0px #2c3035;
}
/* .myButton:hover {
	background:linear-gradient(to bottom, #1e62d0 5%, #3d94f6 100%);
	background-color:#1e62d0;
}
.myButton:active {
	position:relative;
	top:1px;
} */

i.fas.fa-chevron-down.animated.pulse.animated-infinite {
    bottom: 11px;
    position: absolute;
    text-align: center;
    width: 100%;
}
.fa-chevron-down:before {
    color: rgba(255, 255, 255, 0.30196078431372547);
    font-size: 20px;
}
@font-face {
  font-family: Digitalt;
  src: url(/static/assets/lib/Digitalt.otf);
}
.follow-title {
  font-family: Digitalt;
  color: #33adff;
  font-size: 58px;
}
.follow-subtitle {
  font-family: Digitalt;
  font-size: 26px;
}
.follow-subtitle2 {
  font-family: Digitalt;
  font-size: 23px;
  color: #febf45;
  margin: 0 0 0px;
  line-height: 1;
  font-weight: 100;
  padding-top: 0px;
}
.slice-tower,
.game-title .crossbow {
  min-width: unset;
  width: unset;
  max-width: unset;
  min-height: unset;
  height: unset;
  margin: 0 auto;
}

.follow-btn {
  width: 402px;
}

.crossbow {
  position: absolute;
  object-fit: contain;
  left: unset;
  bottom: unset;
  min-width: unset;
  min-height: unset;
}

.slice-tower {
  position: absolute;
  left: unset;
  object-fit: contain;
  bottom: unset;
}

.subtitle-img {
  z-index: 9;
  left: 19%;
  top: 2%;
  position: absolute;
}

.fade-in.three {
  -webkit-animation-delay: 2.6s;
  -moz-animation-delay: 2.6s;
  animation-delay: 2.6s;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.follow::before,
.follow::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.follow {
  position: absolute;
  top: 93%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.suscribe {
  margin-left: 50%;
  margin-top: 48%;
  transform: translateZ(600px);
}

.parallax {
  position: relative;
  width: 100%;
  height: 800px;
  left: 0;
}

.cd-floating-background {
  position: absolute;
  right: 0;
}
.cd-background-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  position: relative;
}

.dwerveTitle {
  position: absolute;
  margin: auto;
  object-fit: cover;
  object-position: 50% 100% !important;
  height: auto !important;
  bottom: 0;
  width: 57% !important;
  left: 3% !important;
  min-width: unset;
  min-height: unset;
}

.background {
  position: absolute;
  z-index: -1;
  min-width: unset;
  margin: auto;
  width: 100% !important;
  min-width: unset;
  min-height: unset;
  top: unset;
  bottom: unset;
  object-fit: cover;
  object-position: 100% 100% !important;
}

@media (min-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    height: auto;
    margin-top: 0;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: 33% !important;
    margin-top: auto !important;
  }
  .follow {
    top: 90%;
  }
  .background {
    height: auto;
  }
}

@media (max-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: 39% !important;
  }
  .follow {
    top: 87%;
  }
  .background {
    height: 100%;
  }
}

@media only screen and (max-width: 1070px) {
  .background{
    object-position: 50% 100% !important;
  }

  .dwerveTitle {
    width: 80% !important;
    margin-bottom: 24%;
    left: -11% !important;
  }
  .follow {
    font-size: 5vw;
  }
  .slice-tower {
    display: none;
  }
}
@media only screen and (min-width: 500px) and (max-width: 600px) {
  .dwerveTitle {
    width: 85% !important;
    margin-bottom: 19%;
    left: -2% !important;
  }
  .follow {
    font-size: 3vw;
    top: 81%;
  }
}
@media only screen and (min-width: 200px) and (max-width: 600px) {
  .dwerveTitle {
   margin-bottom: 40% !important;
  }
  .follow {
    font-size: 3vw;
    top: 90%;
  }
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
  .dwerveTitle {
    width: 83% !important;
    top: 40% !important;
    left: -4% !important;
  }
  .follow {
    font-size: 3vw;
    top: 90%;
  }
}
@media only screen and (min-width: 800px) and (max-width: 900px) {
  .dwerveTitle {
    width: 85% !important;
    top: 59% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 3vw;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1100px) {
  .dwerveTitle {
    width: 74% !important;
    top: 39% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 2.6vw;
  }
}
@media only screen and (width: 1024) {
  .dwerveTitle {
    width: 70% !important;
    margin-bottom: 21%;
    left: 16% !important;
  }
}

@media (width: 375px) {
  .dwerveTitle {
    margin-bottom: 27%;
  }
}

.spider-hanging {
  position: absolute;
  top: -115%;
  width: 15%;
}
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  display: none;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: #0d182de6; /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}

/* Position the content inside the overlay */
.overlay-content {
  position: relative;
  top: 21%;
  width: 54%;
  left: 25%;
  text-align: center;
  margin-top: 30px;
}

/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #fff;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
}
.overlay-content input#semail {
  height: 69px;
}
@media screen and (max-height: 750px) {
  .overlay-content {
    position: relative;
    top: 30%;
    width: auto;
    left: 0;
    text-align: center;
    margin-top: 0;
}
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  z-index: 1;
}

/* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.follow-form {
  padding-top: 0px;
  width: 53%;
  margin-left: 24%;
}
.fade-in-overlay {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
#heroheader .col-xs-12 {
  padding-left: 0%;
  padding-right: 0%;
  z-index: 1;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }

  section#cta1 button {
    width: 112px;
    font-size: 22px;
    padding-left: 10px !important;
}
}
/* Mailtrain styles */
#heroheader .form-group.email label {
  display: none;
}
#heroheader .form-group {
  display: inline-block;
}

#heroheader .form-group.email input {
  top: -9px;
  left: 6px;
}
#heroheader .form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
#heroheader .mailtrain-subscription-widget h3 {
  display: none;
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  #heroheader form.form button {
    font-size: 24px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  #heroheader form.form button {
    font-size: 19px;
    height: 39px;
        width: 132px;
  }
  #heroheader .form-group.email input {
    height: 39px;
  }
  .cta-subtitle {
    padding-top: 32px;
  }
  .follow-title {
    font-size: 26px;
  }
  .follow-subtitle {
    font-size: 14px;
  }
  .follow-subtitle2 {
    font-size: 18px !important;
    padding-top: 0px;
  }
  .images {
    width: 121.17%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/HeroHeader.vue